<app-header></app-header>
<div class="dashboard-content">
  <img class="desktop" src="../../../assets/images/desktop.png" />
  <img class="mobile" src="../../../assets/images/mobile.png" />
</div>
<app-footer></app-footer>
